module.exports = __webpack_public_path__ + "static/media/cabbage-labels.6b809fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cabbage-labels.jpg
// module id = 244
// module chunks = 1